import Facebook from './facebook/FacebookProvider';
import Google from './google/GoogleProvider';
import Apple from './apple/AppleProvider';

const Provider = { Facebook, Google, Apple };
export default Provider;
